import type { PlatformAuditService } from '../../platformContracts';
import { delay, matches, paginate, pctx, platformRoot } from './context';

export const platformAudit: PlatformAuditService = {
  async list(q) {
    pctx('platform.audit.view');
    const from = q.from ? Date.parse(q.from) : undefined;
    const to = q.to ? Date.parse(q.to) + 86_400_000 - 1 : undefined;
    const rows = platformRoot().auditLog.filter((e) =>
      (!q.targetType || q.targetType === 'all' || e.targetType === q.targetType)
      && (from == null || Date.parse(e.at) >= from) && (to == null || Date.parse(e.at) <= to)
      && matches(q.q, e.actorName, e.actorEmail, e.targetLabel, e.summary, e.action));
    return delay(paginate(rows, q.page, q.pageSize ?? 15));
  },
};
